import type { SVGProps } from "react";

interface LogoTallProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

const LogoTall = ({ className, ...props }: LogoTallProps) => (
  <svg
    viewBox="0 0 251 173"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g transform="matrix(1,0,0,1,-55.0489,-163.736)">
      <g transform="matrix(0,-0.75,0.75,0,73.3565,332.125)">
        <path
          d="M-0,1.33L219.021,1.33"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.67"
        />
      </g>
      <g transform="matrix(-0.749999,-0.000876114,0.000876114,-0.749999,223.437,230.82)">
        <path
          d="M0.001,1.337L219.022,1.331"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.67"
        />
      </g>
      <g transform="matrix(1,0,0,1,84.8518,213.915)">
        <path
          d="M15.458,-32.479L15.458,-33.271L2.125,-33.271L2.125,-32.479L6.396,-32.479L6.396,-0.792L2.125,-0.792L2.125,0L15.458,0L15.458,-0.792L11.188,-0.792L11.188,-32.479L15.458,-32.479Z"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,113.226,213.915)">
        <path
          d="M22.333,-33.625L20.896,-31.792C20.297,-32.125 19.734,-32.422 19.208,-32.687C18.677,-32.948 18.146,-33.167 17.604,-33.333C17.063,-33.5 16.484,-33.615 15.875,-33.687C15.26,-33.771 14.563,-33.812 13.771,-33.812C12.146,-33.812 10.693,-33.547 9.417,-33.021C8.151,-32.49 7.073,-31.781 6.188,-30.896C5.297,-30.005 4.615,-28.984 4.146,-27.833C3.688,-26.677 3.458,-25.458 3.458,-24.167C3.458,-22.417 3.99,-20.812 5.063,-19.354C6.146,-17.906 7.823,-16.802 10.104,-16.042C11.188,-15.677 12.109,-15.38 12.875,-15.146C13.635,-14.922 14.344,-14.698 15,-14.479C15.667,-14.271 16.333,-14.042 17,-13.792C17.677,-13.542 18.464,-13.198 19.354,-12.771C20.479,-12.24 21.234,-11.505 21.625,-10.562C22.026,-9.63 22.229,-8.687 22.229,-7.729C22.229,-6.531 22,-5.448 21.542,-4.479C21.083,-3.505 20.469,-2.687 19.708,-2.021C18.943,-1.365 18.068,-0.859 17.083,-0.5C16.094,-0.135 15.089,0.042 14.063,0.042C12.865,0.042 11.729,-0.156 10.646,-0.562C9.563,-0.979 8.552,-1.562 7.625,-2.312C6.708,-3.073 5.906,-4.021 5.229,-5.146C4.547,-6.271 4.026,-7.526 3.667,-8.917C3.568,-9.344 3.385,-9.562 3.125,-9.562C2.885,-9.562 2.771,-9.323 2.771,-8.854L2.771,0C2.771,0.427 2.922,0.646 3.229,0.646C3.422,0.646 3.63,0.479 3.854,0.146L5.646,-2.417C6.047,-2.052 6.531,-1.672 7.104,-1.271C7.688,-0.88 8.333,-0.521 9.042,-0.187C9.75,0.13 10.505,0.396 11.313,0.604C12.115,0.823 12.948,0.938 13.813,0.938C15.396,0.938 16.859,0.646 18.208,0.063C19.568,-0.505 20.74,-1.297 21.729,-2.312C22.729,-3.339 23.51,-4.552 24.083,-5.958C24.667,-7.359 24.958,-8.875 24.958,-10.5C24.958,-12.708 24.438,-14.573 23.396,-16.104C22.354,-17.646 20.714,-18.75 18.479,-19.417C17.714,-19.635 17,-19.833 16.333,-20C15.677,-20.167 15.005,-20.344 14.313,-20.542C13.615,-20.75 12.885,-20.969 12.125,-21.208C11.375,-21.458 10.531,-21.771 9.604,-22.146C8.573,-22.531 7.797,-23.135 7.271,-23.958C6.74,-24.792 6.479,-25.75 6.479,-26.833C6.479,-27.859 6.693,-28.76 7.125,-29.542C7.552,-30.318 8.109,-30.948 8.792,-31.437C9.469,-31.937 10.25,-32.312 11.125,-32.562C12,-32.812 12.88,-32.937 13.771,-32.937C15.115,-32.937 16.302,-32.698 17.333,-32.229C18.359,-31.771 19.214,-31.156 19.896,-30.396C20.589,-29.646 21.146,-28.771 21.563,-27.771C21.979,-26.781 22.25,-25.76 22.375,-24.708C22.417,-24.375 22.568,-24.208 22.833,-24.208C23.052,-24.208 23.167,-24.375 23.167,-24.708L23.167,-33.521C23.167,-33.854 23.068,-34.021 22.875,-34.021C22.708,-34.021 22.526,-33.885 22.333,-33.625Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,150.86,213.915)">
        <path
          d="M10.688,-17.125L14.604,-17.125C15.339,-17.125 15.917,-17.021 16.333,-16.812C16.76,-16.604 17.104,-16.297 17.354,-15.896C17.604,-15.49 17.792,-15.01 17.917,-14.458C18.052,-13.901 18.188,-13.276 18.313,-12.583C18.422,-12.109 18.563,-11.875 18.729,-11.875C18.922,-11.875 19.021,-12.089 19.021,-12.521L19.021,-22.583C19.021,-22.969 18.922,-23.167 18.729,-23.167C18.563,-23.167 18.422,-22.937 18.313,-22.479C18.188,-21.781 18.052,-21.151 17.917,-20.583C17.792,-20.026 17.604,-19.547 17.354,-19.146C17.104,-18.755 16.76,-18.448 16.333,-18.229C15.917,-18.021 15.339,-17.917 14.604,-17.917L10.688,-17.917L10.688,-32.479L18.229,-32.479C19.354,-32.479 20.292,-32.208 21.042,-31.667C21.802,-31.125 22.417,-30.443 22.875,-29.625C23.333,-28.818 23.667,-27.964 23.875,-27.062C24.094,-26.156 24.229,-25.339 24.271,-24.604C24.271,-24.146 24.401,-23.917 24.667,-23.917C24.885,-23.917 25,-24.13 25,-24.562L25,-32.083C25,-32.875 24.589,-33.271 23.771,-33.271L1.625,-33.271L1.625,-32.479L5.896,-32.479L5.896,-0.792L1.688,-0.792L1.688,0L24.958,0C25.917,0 26.396,-0.526 26.396,-1.583L26.396,-9.021C26.396,-9.812 26.26,-10.208 26,-10.208C25.76,-10.208 25.583,-9.859 25.458,-9.167C25.193,-7.901 24.906,-6.755 24.604,-5.729C24.313,-4.714 23.917,-3.833 23.417,-3.083C22.927,-2.344 22.302,-1.776 21.542,-1.375C20.776,-0.984 19.818,-0.792 18.667,-0.792L10.688,-0.792L10.688,-17.125Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,190.079,213.915)">
        <path
          d="M27.479,-9.167C27.214,-7.901 26.927,-6.755 26.625,-5.729C26.333,-4.714 25.938,-3.833 25.438,-3.083C24.948,-2.344 24.323,-1.776 23.563,-1.375C22.813,-0.984 21.859,-0.792 20.708,-0.792L10.542,-0.792L10.542,-32.479L15.25,-32.479L15.25,-33.271L1.479,-33.271L1.479,-32.479L5.75,-32.479L5.75,-0.792L1.479,-0.792L1.479,0L26.979,0C27.938,0 28.417,-0.526 28.417,-1.583L28.417,-9.021C28.417,-9.812 28.281,-10.208 28.021,-10.208C27.797,-10.208 27.615,-9.859 27.479,-9.167Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,230.535,213.915)">
        <path
          d="M16.188,-33.271L1.583,-33.271L1.583,-32.479L5.938,-32.479L5.938,-0.792L1.583,-0.792L1.583,0L16.188,0C18.505,0 20.615,-0.401 22.521,-1.208C24.438,-2.01 26.068,-3.156 27.417,-4.646C28.776,-6.13 29.823,-7.922 30.563,-10.021C31.313,-12.115 31.688,-14.458 31.688,-17.042C31.688,-19.443 31.302,-21.646 30.542,-23.646C29.792,-25.646 28.729,-27.359 27.354,-28.792C25.99,-30.234 24.359,-31.339 22.458,-32.104C20.552,-32.88 18.464,-33.271 16.188,-33.271ZM26.25,-18.271L26.25,-15.792C26.25,-12.859 25.969,-10.427 25.417,-8.5C24.875,-6.568 24.135,-5.031 23.208,-3.896C22.292,-2.755 21.219,-1.948 20,-1.479C18.776,-1.021 17.479,-0.792 16.104,-0.792L10.75,-0.792L10.75,-32.479L16.104,-32.479C17.448,-32.479 18.734,-32.234 19.958,-31.75C21.177,-31.276 22.255,-30.484 23.188,-29.375C24.13,-28.276 24.875,-26.818 25.417,-25C25.969,-23.193 26.25,-20.948 26.25,-18.271Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,274.111,213.915)">
        <path
          d="M1.083,-0.792L1.083,0L12.083,0L12.083,-0.792L6.25,-0.792L9.354,-10.354L19.313,-10.354L22.542,-0.792L17.438,-0.792L17.438,0L31.938,0L31.938,-0.792L27.625,-0.792L16.792,-33.729L16.188,-33.729L5.354,-0.792L1.083,-0.792ZM14.313,-25.312L19.063,-11.146L9.667,-11.146L14.313,-25.312Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,90.1078,259.217)">
        <rect
          x="1.438"
          y="-10.875"
          width="1.542"
          height="10.875"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,98.0118,259.217)">
        <path
          d="M8.625,0L10,0L10,-10.875L8.458,-10.875L8.458,-2.833L2.792,-10.875L1.438,-10.875L1.438,0L2.979,0L2.979,-8.104L8.625,0Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,112.94,259.217)">
        <path
          d="M5.292,0C6.333,0 7.219,-0.234 7.958,-0.708C8.693,-1.177 9.25,-1.823 9.625,-2.646C10.01,-3.479 10.208,-4.427 10.208,-5.5C10.208,-7.109 9.797,-8.406 8.979,-9.396C8.172,-10.38 6.964,-10.875 5.354,-10.875L1.438,-10.875L1.438,0L5.292,0ZM5.417,-9.562C6.5,-9.562 7.302,-9.193 7.833,-8.458C8.375,-7.734 8.646,-6.74 8.646,-5.479C8.646,-4.146 8.339,-3.109 7.729,-2.375C7.13,-1.635 6.318,-1.271 5.292,-1.271L2.979,-1.271L2.979,-9.562L5.417,-9.562Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,127.276,259.217)">
        <rect
          x="1.438"
          y="-10.875"
          width="1.542"
          height="10.875"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,135.18,259.217)">
        <path
          d="M4.354,0L5.75,0L9.833,-10.875L8.333,-10.875L5.063,-2.062L1.688,-11L0.167,-10.792L4.354,0Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,148.668,259.217)">
        <rect
          x="1.438"
          y="-10.875"
          width="1.542"
          height="10.875"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,156.572,259.217)">
        <path
          d="M5.292,0C6.333,0 7.219,-0.234 7.958,-0.708C8.693,-1.177 9.25,-1.823 9.625,-2.646C10.01,-3.479 10.208,-4.427 10.208,-5.5C10.208,-7.109 9.797,-8.406 8.979,-9.396C8.172,-10.38 6.964,-10.875 5.354,-10.875L1.438,-10.875L1.438,0L5.292,0ZM5.417,-9.562C6.5,-9.562 7.302,-9.193 7.833,-8.458C8.375,-7.734 8.646,-6.74 8.646,-5.479C8.646,-4.146 8.339,-3.109 7.729,-2.375C7.13,-1.635 6.318,-1.271 5.292,-1.271L2.979,-1.271L2.979,-9.562L5.417,-9.562Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,170.908,259.217)">
        <path
          d="M1.271,-3.896C1.271,-3.115 1.443,-2.417 1.792,-1.792C2.135,-1.167 2.63,-0.677 3.271,-0.333C3.922,0 4.672,0.167 5.521,0.167C6.365,0.167 7.109,-0.005 7.75,-0.354C8.401,-0.698 8.896,-1.177 9.229,-1.792C9.573,-2.417 9.75,-3.115 9.75,-3.896L9.75,-10.875L8.208,-10.875L8.208,-4.042C8.208,-3.135 7.964,-2.417 7.479,-1.875C7.005,-1.344 6.354,-1.083 5.521,-1.083C4.714,-1.083 4.063,-1.344 3.563,-1.875C3.063,-2.401 2.813,-3.125 2.813,-4.042L2.813,-10.875L1.271,-10.875L1.271,-3.896Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,185.436,259.217)">
        <path
          d="M2.979,-1.208L2.979,-4.937L6.875,-4.937L6.667,-6.125L2.979,-6.125L2.979,-9.687L7.771,-9.687L7.563,-10.875L1.438,-10.875L1.438,0L8.354,0L8.146,-1.208L2.979,-1.208Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,197.596,259.217)">
        <path
          d="M2.979,-10.875L1.438,-10.875L1.438,0L8.083,0L7.896,-1.208L2.979,-1.208L2.979,-10.875Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,209.324,259.217)">
        <path
          d="M2.979,-1.208L2.979,-4.937L6.875,-4.937L6.667,-6.125L2.979,-6.125L2.979,-9.687L7.771,-9.687L7.563,-10.875L1.438,-10.875L1.438,0L8.354,0L8.146,-1.208L2.979,-1.208Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,221.484,259.217)">
        <path
          d="M1.479,-1.917C1.229,-1.917 1.005,-1.818 0.813,-1.625C0.615,-1.443 0.521,-1.219 0.521,-0.958C0.521,-0.719 0.604,-0.505 0.771,-0.312C0.938,-0.115 1.115,-0.01 1.313,0C1.281,0.292 1.188,0.531 1.021,0.729C0.865,0.922 0.63,1.135 0.313,1.375L0.688,2.104C1.198,1.823 1.625,1.406 1.958,0.854C2.302,0.313 2.479,-0.229 2.479,-0.771C2.479,-1.104 2.38,-1.375 2.188,-1.583C2.005,-1.802 1.771,-1.917 1.479,-1.917Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,90.1078,281.217)">
        <path
          d="M2.979,0L2.979,-4.354L4.396,-4.354C4.896,-4.354 5.234,-4.365 5.417,-4.396L7.833,0L9.5,0L6.771,-4.792C7.339,-5.042 7.792,-5.406 8.125,-5.896C8.469,-6.38 8.651,-6.964 8.667,-7.646C8.667,-8.729 8.281,-9.531 7.521,-10.062C6.771,-10.604 5.781,-10.875 4.563,-10.875L1.438,-10.875L1.438,0L2.979,0ZM4.542,-9.583C5.359,-9.583 5.984,-9.427 6.417,-9.125C6.844,-8.818 7.063,-8.302 7.063,-7.583C7.063,-6.885 6.818,-6.38 6.333,-6.062C5.859,-5.755 5.234,-5.604 4.458,-5.604L2.979,-5.604L2.979,-9.583L4.542,-9.583Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,103.26,281.217)">
        <path
          d="M2.979,-1.208L2.979,-4.937L6.875,-4.937L6.667,-6.125L2.979,-6.125L2.979,-9.687L7.771,-9.687L7.563,-10.875L1.438,-10.875L1.438,0L8.354,0L8.146,-1.208L2.979,-1.208Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,115.42,281.217)">
        <path
          d="M2.979,-10.875L1.438,-10.875L1.438,0L8.083,0L7.896,-1.208L2.979,-1.208L2.979,-10.875Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,127.148,281.217)">
        <path
          d="M1.667,0L2.75,-2.917L7.188,-2.917L8.313,0.125L9.833,-0.104L5.646,-10.875L4.25,-10.875L0.167,0L1.667,0ZM4.938,-8.812L6.729,-4.146L3.188,-4.146L4.938,-8.812Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,140.636,281.217)">
        <path
          d="M0.167,-9.667L3.688,-9.667L3.688,0L5.25,0L5.25,-9.667L9,-9.667L8.792,-10.875L0.167,-10.875L0.167,-9.667Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,153.276,281.217)">
        <rect
          x="1.438"
          y="-10.875"
          width="1.542"
          height="10.875"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,161.18,281.217)">
        <path
          d="M2.979,-1.208L2.979,-4.937L6.875,-4.937L6.667,-6.125L2.979,-6.125L2.979,-9.687L7.771,-9.687L7.563,-10.875L1.438,-10.875L1.438,0L8.354,0L8.146,-1.208L2.979,-1.208Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,173.34,281.217)">
        <path
          d="M0.625,-3.75L4.708,-3.75L4.563,-4.979L0.479,-4.979L0.625,-3.75Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,182.012,281.217)">
        <path
          d="M1.479,-1.917C1.229,-1.917 1.005,-1.818 0.813,-1.625C0.615,-1.443 0.521,-1.219 0.521,-0.958C0.521,-0.719 0.604,-0.505 0.771,-0.312C0.938,-0.115 1.115,-0.01 1.313,0C1.281,0.292 1.188,0.531 1.021,0.729C0.865,0.922 0.63,1.135 0.313,1.375L0.688,2.104C1.198,1.823 1.625,1.406 1.958,0.854C2.302,0.313 2.479,-0.229 2.479,-0.771C2.479,-1.104 2.38,-1.375 2.188,-1.583C2.005,-1.802 1.771,-1.917 1.479,-1.917Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,195.628,281.217)">
        <path
          d="M2.979,-1.208L2.979,-4.937L6.875,-4.937L6.667,-6.125L2.979,-6.125L2.979,-9.687L7.771,-9.687L7.563,-10.875L1.438,-10.875L1.438,0L8.354,0L8.146,-1.208L2.979,-1.208Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,207.788,281.217)">
        <path
          d="M8.625,0L10,0L10,-10.875L8.458,-10.875L8.458,-2.833L2.792,-10.875L1.438,-10.875L1.438,0L2.979,0L2.979,-8.104L8.625,0Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,90.1078,303.217)">
        <path
          d="M7.979,-1.208C7.38,-0.984 6.76,-0.875 6.125,-0.875C5.344,-0.875 4.646,-1.052 4.021,-1.417C3.396,-1.792 2.901,-2.318 2.542,-3C2.193,-3.693 2.021,-4.49 2.021,-5.396C2.021,-6.339 2.214,-7.156 2.604,-7.854C3.005,-8.562 3.531,-9.094 4.188,-9.458C4.854,-9.833 5.563,-10.021 6.313,-10.021C6.813,-10.021 7.214,-9.984 7.521,-9.917C7.823,-9.844 8.193,-9.729 8.625,-9.562L9.021,-10.479C8.714,-10.672 8.276,-10.823 7.708,-10.937C7.151,-11.047 6.677,-11.104 6.292,-11.104C5.25,-11.104 4.297,-10.859 3.438,-10.375C2.589,-9.885 1.917,-9.208 1.417,-8.333C0.927,-7.469 0.688,-6.484 0.688,-5.375C0.688,-4.318 0.906,-3.365 1.354,-2.521C1.813,-1.672 2.448,-1 3.271,-0.5C4.104,-0.01 5.063,0.229 6.146,0.229C6.672,0.229 7.219,0.151 7.792,0C8.375,-0.135 8.839,-0.312 9.188,-0.521L9.208,-5.604L5.688,-5.604L5.583,-4.646L7.979,-4.646L7.979,-1.208Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,103.628,303.217)">
        <path
          d="M2.75,-1L2.75,-5.083L6.646,-5.083L6.521,-6.042L2.75,-6.042L2.75,-9.937L7.563,-9.937L7.417,-10.875L1.479,-10.875L1.479,0L8.042,0L7.896,-1L2.75,-1Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,115.484,303.217)">
        <path
          d="M8.625,-9.896L8.521,-10.875L0.792,-10.875L1,-9.896L7.208,-9.896L0.375,-1L0.5,0L8.479,0L8.375,-1L1.75,-1L8.625,-9.896Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,127.964,303.217)">
        <rect
          x="1.479"
          y="-10.875"
          width="1.271"
          height="10.875"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,135.676,303.217)">
        <path
          d="M3.167,-7.833L8.708,0L9.729,0L9.729,-10.875L8.458,-10.875L8.458,-2.458L7.792,-3.521L2.5,-10.875L1.479,-10.875L1.479,0L2.75,0L2.75,-8.542L3.167,-7.833Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,150.364,303.217)">
        <path
          d="M0.854,-0.521C1.146,-0.339 1.594,-0.172 2.208,-0.021C2.833,0.13 3.38,0.208 3.854,0.208C4.646,0.208 5.333,0.089 5.917,-0.146C6.5,-0.396 6.938,-0.734 7.229,-1.167C7.531,-1.594 7.688,-2.089 7.688,-2.646C7.688,-3.156 7.583,-3.594 7.375,-3.958C7.167,-4.333 6.854,-4.656 6.438,-4.937C6.031,-5.229 5.49,-5.526 4.813,-5.833C4.063,-6.177 3.49,-6.464 3.104,-6.687C2.729,-6.906 2.438,-7.151 2.229,-7.417C2.021,-7.693 1.917,-8.026 1.917,-8.417C1.917,-8.927 2.125,-9.323 2.542,-9.604C2.969,-9.896 3.542,-10.042 4.25,-10.042C4.708,-10.042 5.094,-9.99 5.417,-9.896C5.75,-9.797 6.115,-9.656 6.521,-9.479L6.938,-10.458C6.563,-10.651 6.13,-10.812 5.646,-10.937C5.172,-11.073 4.677,-11.146 4.167,-11.146C3.469,-11.146 2.859,-11.021 2.333,-10.771C1.802,-10.531 1.396,-10.208 1.104,-9.792C0.823,-9.375 0.688,-8.906 0.688,-8.396C0.688,-7.672 0.917,-7.062 1.375,-6.562C1.844,-6.062 2.573,-5.594 3.563,-5.167C4.255,-4.875 4.802,-4.609 5.208,-4.375C5.609,-4.151 5.917,-3.896 6.125,-3.604C6.344,-3.323 6.458,-3 6.458,-2.625C6.458,-2.094 6.229,-1.667 5.771,-1.333C5.313,-1.01 4.667,-0.854 3.833,-0.854C3.375,-0.854 2.901,-0.922 2.417,-1.062C1.927,-1.198 1.51,-1.354 1.167,-1.521L0.854,-0.521Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,162.06,303.217)">
        <path
          d="M0.167,-9.896L3.813,-9.896L3.813,0L5.083,0L5.083,-9.896L8.854,-9.896L8.708,-10.875L0.167,-10.875L0.167,-9.896Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,174.556,303.217)">
        <path
          d="M7.854,-10.875L7.854,-6L2.75,-6L2.75,-10.958L1.479,-10.875L1.479,0L2.75,0L2.75,-4.979L7.854,-4.979L7.854,0L9.125,0L9.125,-10.875L7.854,-10.875Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,188.652,303.217)">
        <path
          d="M2.75,-1L2.75,-5.083L6.646,-5.083L6.521,-6.042L2.75,-6.042L2.75,-9.937L7.563,-9.937L7.417,-10.875L1.479,-10.875L1.479,0L8.042,0L7.896,-1L2.75,-1Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,200.508,303.217)">
        <path
          d="M2.75,0L2.75,-4.458L4.292,-4.458C4.667,-4.458 5.042,-4.479 5.417,-4.521L7.917,0L9.313,0L6.542,-4.854C7.125,-5.104 7.589,-5.464 7.938,-5.937C8.281,-6.406 8.458,-7 8.458,-7.708C8.458,-8.802 8.094,-9.604 7.375,-10.104C6.651,-10.615 5.677,-10.875 4.458,-10.875L1.479,-10.875L1.479,0L2.75,0ZM4.458,-9.812C5.318,-9.812 5.984,-9.651 6.458,-9.333C6.927,-9.01 7.167,-8.458 7.167,-7.667C7.151,-6.901 6.885,-6.344 6.375,-6C5.859,-5.667 5.177,-5.5 4.333,-5.5L2.75,-5.5L2.75,-9.812L4.458,-9.812Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,213.468,303.217)">
        <path
          d="M1.396,0L2.521,-3.083L7.125,-3.083L8.333,0.104L9.583,-0.104L5.417,-10.875L4.188,-10.875L0.167,0L1.396,0ZM4.792,-9.208L6.75,-4.104L2.875,-4.104L4.792,-9.208Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,226.7,303.217)">
        <path
          d="M4.292,-4.104C5.5,-4.104 6.49,-4.396 7.271,-4.979C8.063,-5.562 8.458,-6.417 8.458,-7.542C8.458,-8.693 8.094,-9.531 7.375,-10.062C6.651,-10.604 5.677,-10.875 4.458,-10.875L1.479,-10.875L1.479,0L2.75,0L2.75,-4.104L4.292,-4.104ZM4.458,-9.812C5.344,-9.812 6.021,-9.635 6.479,-9.292C6.938,-8.943 7.167,-8.344 7.167,-7.5C7.151,-6.708 6.885,-6.125 6.375,-5.75C5.859,-5.375 5.177,-5.187 4.333,-5.187L2.75,-5.187L2.75,-9.812L4.458,-9.812Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,239.18,303.217)">
        <rect
          x="1.479"
          y="-10.875"
          width="1.271"
          height="10.875"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
      <g transform="matrix(1,0,0,1,246.892,303.217)">
        <path
          d="M2.75,-1L2.75,-5.083L6.646,-5.083L6.521,-6.042L2.75,-6.042L2.75,-9.937L7.563,-9.937L7.417,-10.875L1.479,-10.875L1.479,0L8.042,0L7.896,-1L2.75,-1Z"
          fillRule="nonzero"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default LogoTall;
